import React from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const toastMes = {
  success(msg) {
    return toast.info(typeof msg === "string" ? msg : JSON.stringify(msg));
  },
  info(msg) {
    return toast.info(typeof msg === "string" ? msg : JSON.stringify(msg));
  },
  warning(msg) {
    return toast.warning(typeof msg === "string" ? msg : JSON.stringify(msg));
  },
  error(msg) {
    if (!msg) {
      return toast.info("An unexpected error occurred");
    }
    if (typeof msg === "string") {
      return toast.info(msg);
    }
    const extracted =
      msg?.response?.data?.message ||
      msg?.response?.data?.error ||
      msg?.data?.message ||
      msg?.data?.error ||
      msg?.message ||
      msg?.error ||
      "An unexpected error occurred";
    return toast.info(typeof extracted === "string" ? extracted : JSON.stringify(extracted));
  },
};

const CustomToastify = ({ bgColor, duration }) => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={duration}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{
          backgroundColor: "#0851A0",
          color: "white",
          width: "500px",
          left: "-180px",
        }}
      />
    </>
  );
};

export default CustomToastify;
